import React, { Children, cloneElement, isValidElement } from 'react';
import Box from '../Box';
import Menu from '../Menu';
import { shallowEqual } from '../utils';
import { OPTIONGROUP_DISPLAY_NAME, OPTION_DISPLAY_NAME } from './constants';
import Option from './Option';
import OptionGroup from './OptionGroup';
export function getSelectedOptions(children, selected) {
  var selectedChildren = [];
  var index = -1;

  function getSelectedOption(child) {
    index++;

    if (selected(child.props.value)) {
      return {
        index: index,
        value: child.props.value,
        text: child.props.text,
        children: typeof child.props.children === 'function' ? child.props.children() : child.props.children
      };
    } else {
      return false;
    }
  }

  function pushSelectedOption(child) {
    var option = getSelectedOption(child);

    if (option) {
      selectedChildren.push(option);
    }
  }

  Children.toArray(children).forEach(function (child) {
    if (child) {
      if (child.type.displayName === OPTIONGROUP_DISPLAY_NAME) {
        Children.toArray(child.props.children).filter(isValidElement).forEach(function (grandChild) {
          if (grandChild.type.displayName === OPTION_DISPLAY_NAME) {
            pushSelectedOption(grandChild);
          }
        });
      }

      if (child.type.displayName === OPTION_DISPLAY_NAME) {
        pushSelectedOption(child);
      }
    }
  });
  return selectedChildren;
}
export function renderOptions(children) {
  var index = -1;

  function renderOption(child) {
    index++;
    return /*#__PURE__*/cloneElement(child, {
      index: index
    });
  }

  return Children.map(children, function (child) {
    if (child) {
      if (child.type.displayName === OPTIONGROUP_DISPLAY_NAME) {
        return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Menu.Heading, null, child.props.title), Children.map(child.props.children, renderOption));
      }

      if (child.type.displayName === OPTION_DISPLAY_NAME) {
        return renderOption(child);
      }
    }

    return child;
  });
}
export function optionsToElements(options) {
  return options.map(function (option) {
    return option.optgroup ? /*#__PURE__*/React.createElement(OptionGroup, {
      title: option.label,
      children: option.optgroup.map(function (option) {
        return /*#__PURE__*/React.createElement(Option, {
          value: option.value
        }, option.label);
      })
    }) : /*#__PURE__*/React.createElement(Option, {
      value: option.value
    }, option.label);
  });
}
export function toggleValue(collection, item) {
  var previousValue = false;
  var newValue = collection.reduce(function (newCollection, value) {
    if (shallowEqual(item, value)) {
      previousValue = true;
      return newCollection;
    } else {
      return [].concat(newCollection, [value]);
    }
  }, []);

  if (!previousValue) {
    newValue.push(item);
  }

  return newValue;
}